import React from 'react'

import Button, { ButtonProps } from './Button'

/**
 * プライマリボタン
 */
const PrimaryButton: React.FC<ButtonProps> = (props) => (
  <Button
    {...props}
    color="var(--color-text-for-main-background)"
    background="var(--color-main)"
  />
)

export default PrimaryButton
